import { pageTheme } from '@backstage/theme';
import { v4 } from 'uuid';
import ObservableImpl from 'zen-observable';

class DefaultShortcutsApi {
  constructor(storageApi) {
    this.storageApi = storageApi;
    this.shortcuts = this.storageApi.snapshot("items").value ?? [];
    this.storageApi.observe$("items").subscribe({
      next: (next) => {
        this.shortcuts = next.value ?? [];
        this.notifyChanges();
      }
    });
  }
  shortcuts;
  subscribers = /* @__PURE__ */ new Set();
  observable = new ObservableImpl((subscriber) => {
    subscriber.next(this.shortcuts);
    this.subscribers.add(subscriber);
    return () => {
      this.subscribers.delete(subscriber);
    };
  });
  shortcut$() {
    return this.observable;
  }
  get() {
    return this.shortcuts;
  }
  async add(shortcut) {
    const shortcuts = this.sort([...this.get(), { ...shortcut, id: v4() }]);
    await this.storageApi.set("items", shortcuts);
  }
  async remove(id) {
    const shortcuts = this.get().filter((s) => s.id !== id);
    await this.storageApi.set("items", shortcuts);
  }
  async update(shortcut) {
    const shortcuts = this.get().filter((s) => s.id !== shortcut.id);
    shortcuts.push(shortcut);
    await this.storageApi.set("items", shortcuts);
  }
  getColor(url) {
    const type = url.split("/")[1];
    const theme = this.THEME_MAP[type] ?? (Object.keys(pageTheme).includes(type) ? type : "tool");
    return pageTheme[theme].colors[0];
  }
  THEME_MAP = {
    catalog: "home",
    docs: "documentation"
  };
  sort(shortcuts) {
    return shortcuts.slice().sort((a, b) => a.title >= b.title ? 1 : -1);
  }
  notifyChanges() {
    for (const subscription of this.subscribers) {
      subscription.next(this.shortcuts);
    }
  }
}

export { DefaultShortcutsApi };
//# sourceMappingURL=DefaultShortcutsApi.esm.js.map
